import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("ao_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  const actAs = localStorage.getItem("ao_act_as");
  if (actAs && window.location.pathname.startsWith("/manufacturer")) c.headers["X-Act-As-Manufacturer"] = actAs;
  return c;
});

export const img = (u) => (u && u.startsWith("/api") ? BACKEND + u : u);
export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
export const fmtDate = (s) => new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
